import { render, staticRenderFns } from "./TipoBien.vue?vue&type=template&id=6fe3dfc0"
import script from "./TipoBien.vue?vue&type=script&lang=js"
export * from "./TipoBien.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports